import { inject } from 'vue';

export default function useBoardEmbed() {
  const embeddedBoardAttributes = inject('embeddedBoardAttributes', {});
  const embed = inject('embed', false);
  const inEpicBoard = inject('inEpicBoard', false);

  return {
    embeddedBoardAttributes,
    embed,
    inEpicBoard,
  };
}
